import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateService} from "@ngx-translate/core";
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-website',
   templateUrl: './website.component.html',
   styleUrls: ['./website.component.css']
})
export class WebsiteComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: string;
   @Input() placeholder: any;
   @Input() labelName: any;
   @Input() hideHeader: boolean = false;
   value: any;

   constructor(private eformService: EformService) {
   }

   ngOnInit(): void {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
   }

   onChange(event) {
      const value = event.target.value;
      if (value.indexOf('http') === -1 && value !== '') {
         this.form.controls[this.fieldName].setValue('http://' + value);
      }
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }
}
